import { useEffect, useState, useRef } from "react";
import { FcSalesPerformance } from "react-icons/fc";
import { SlNote } from "react-icons/sl";
import { CgProfile } from "react-icons/cg";

function Cards({ cards }) {
  const cardList = [
    {
      title: "Today Orders",
      value: cards.today_order,
      icon: "🛒",
    },
    {
      title: "Delivery Pending",
      value: cards.pending,
      icon: <SlNote />,
    },
    {
      title: "In Progress",
      value: cards.in_progress,
      icon: <SlNote />,
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [flipping, setFlipping] = useState(false);
  const timeoutRef = useRef(null);

  const triggerFlip = () => {
    setFlipping(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % cardList.length);
      setFlipping(false);
    }, 600); // Animation duration
  };

  const startTimer = () => {
    timeoutRef.current = setTimeout(() => {
      triggerFlip();
      startTimer(); // Restart after each flip
    }, 6000);
  };

  const resetTimer = () => {
    clearTimeout(timeoutRef.current);
    triggerFlip();
    startTimer(); // Restart from click
  };

  useEffect(() => {
    startTimer();
    return () => clearTimeout(timeoutRef.current);
  }, []);

  if (!cards) {
    return null; // or show a loader or fallback UI
  }

  const currentCard = cardList[currentIndex];

  return (
    <div className="card1-row">
      <div className="card1">
        <div className="card1-header">
          <span>Total Sales</span>
          <div className="icon">
            <FcSalesPerformance />
          </div>
        </div>
        <div className="card1-value">₹ {cards.total_sales}</div>
      </div>
      <div className="card1">
        <div className="card1-header">
          <span>Total Orders</span>
          <div className="icon">🛒</div>
        </div>
        <div className="card1-value">{cards.total_order}</div>
      </div>
      <div className="card1">
        <div className="card1-header">
          <span>Total Customers</span>
          <div className="icon">
            <CgProfile />
          </div>
        </div>
        <div className="card1-value">{cards.total_customer}</div>
      </div>

      {/* <div className="card1"> */}
      {/* <div className="flip-card-container" > */}
      <div
        className={`flip-card-container ${flipping ? "flipping" : ""}`}
        onClick={resetTimer}
      >
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <div className="card1-header">
              <span>{currentCard.title}</span>
              <div className="icon">{currentCard.icon}</div>
            </div>
            <div className="card1-value">{currentCard.value}</div>
          </div>
          <div className="flip-card-back">
            <div className="card1-header">
              <span>{currentCard.title}</span>
              <div className="icon">{currentCard.icon}</div>
            </div>
            <div className="card1-value">{currentCard.value}</div>
          </div>
        </div>
      </div>

      {/* </div> */}

      {/* </div> */}

      {/* <div className="card1">
        <div className="card1-header">
          <span>Today Orders</span>
          <div className="icon">🛒</div>
        </div>
        <div className="card1-value">{cards.today_order}</div>
      </div>
      <div className="card1">
        <div className="card1-header">
          <span>Delivery Pending</span>
          <div className="icon">
            <SlNote />
          </div>
        </div>
        <div className="card1-value">{cards.pending}</div>
      </div>
      <div className="card1">
        <div className="card1-header">
          <span>In Progress</span>
          <div className="icon">
            <SlNote />
          </div>
        </div>
        <div className="card1-value">{cards.in_progress}</div>
      </div> */}
    </div>
  );
}

export default Cards;
